module.exports = __webpack_public_path__ + "assets/img/513639b12ef4e751b59f14f1ef426be8.png";